export const GET_MATCHED_LISTINGS_COUNT = 'INVESTORS/GET_MATCHED_LISTINGS_COUNT';
